import React, { useState } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import ShieldIcon from '@mui/icons-material/Shield';
import StarIcon from '@mui/icons-material/Star';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useCountdown } from './useCountdown';
type PackId = 'basic' | 'premium';
const PACKS: Record<PackId, {
  url: string;
  label: string;
}> = {
  basic: {
    url: 'https://pagos.indigo33.shop/cart/63717495505265:1',
    label: '→ QUIERO EL PACK ARTE BORDADO'
  },
  premium: {
    url: 'https://pagos.indigo33.shop/cart/63727324397937:1',
    label: '→ QUIERO EL PACK + CLASES GRABADAS'
  }
};
export function PricingCard() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [selected, setSelected] = useState<PackId>('premium');
  const current = PACKS[selected];
  return <section id="pricing-section" className="py-8 md:py-12 px-4 max-w-2xl mx-auto" data-id="element-198">
      <div className="text-center mb-5" data-id="element-199">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-brand-dark mb-3" data-id="element-200">
          ESTA OFERTA CIERRA EN:
        </h2>
        <div className="flex justify-center gap-2 md:gap-3 mb-3" data-id="element-201">
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-202">
            <span className="text-xl font-mono font-bold block" data-id="element-203">{hours}</span>
            <span className="text-[10px] text-gray-300" data-id="element-204">hs</span>
          </div>
          <div className="text-xl font-bold text-brand-dark self-center" data-id="element-205">:</div>
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-206">
            <span className="text-xl font-mono font-bold block" data-id="element-207">{minutes}</span>
            <span className="text-[10px] text-gray-300" data-id="element-208">min</span>
          </div>
          <div className="text-xl font-bold text-brand-dark self-center" data-id="element-209">:</div>
          <div className="bg-brand-dark text-white rounded-lg p-2 w-16" data-id="element-210">
            <span className="text-xl font-mono font-bold block" data-id="element-211">{seconds}</span>
            <span className="text-[10px] text-gray-300" data-id="element-212">seg</span>
          </div>
        </div>
        <p className="text-red-500 font-bold text-sm" data-id="element-213">
          ⚠️ Después aumenta de precio.
        </p>
      </div>

      <h3 className="font-heading text-2xl md:text-3xl font-bold text-center text-brand-dark mb-4" data-id="element-214">
        ELEGÍ TU <span className="text-brand-pink" data-id="element-215">PACK</span>
      </h3>

      {/* Card 1 — Basic Pack */}
      <button type="button" onClick={() => setSelected('basic')} aria-pressed={selected === 'basic'} className={`w-full text-left bg-white rounded-2xl overflow-hidden relative mb-3 transition-all ${selected === 'basic' ? 'border-2 border-brand-pink shadow-soft' : 'border border-brand-cream shadow-sm'}`} data-id="element-216">
        <div className="p-4 flex items-center gap-3" data-id="element-217">
          {/* Radio indicator */}
          <div className={`w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-brand-pink' : 'border-gray-300'}`} data-id="element-218">
            {selected === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-brand-pink" data-id="element-219" />}
          </div>

          <MenuBookIcon className="text-brand-pink shrink-0" style={{
          fontSize: 24
        }} data-id="element-220" />

          <div className="flex-grow min-w-0" data-id="element-221">
            <h4 className="font-heading text-base md:text-lg font-bold text-brand-dark leading-tight" data-id="element-222">
              PACK ARTE BORDADO
            </h4>
            <p className="text-brand-text text-[11px] md:text-xs" data-id="element-223">
              📘 Tomo 1 + 📙 Tomo 2 + 🎁 4 Bonos
            </p>
            <p className="text-brand-purple text-[11px] md:text-xs font-semibold" data-id="element-224">
              Ideal para aprender desde cero
            </p>
          </div>

          <div className="text-right shrink-0" data-id="element-225">
            <p className="text-gray-400 line-through text-[11px] font-medium" data-id="element-226">
              $49.999
            </p>
            <p className="text-brand-dark font-black text-base md:text-lg" data-id="element-227">
              $19.999
              <span className="text-[10px] font-bold ml-0.5" data-id="element-228">ARS</span>
            </p>
          </div>
        </div>
      </button>

      {/* Card 2 — Upgraded Pack */}
      <button type="button" onClick={() => setSelected('premium')} aria-pressed={selected === 'premium'} className={`w-full text-left bg-white rounded-2xl overflow-hidden relative transition-all ${selected === 'premium' ? 'border-2 border-brand-pink shadow-glow' : 'border border-brand-cream shadow-sm'}`} data-id="element-229">
        <div className="bg-brand-pink text-white text-center py-1 font-bold tracking-wider text-[11px] md:text-xs flex items-center justify-center gap-1.5" data-id="element-230">
          <StarIcon style={{
          fontSize: 12
        }} data-id="element-231" />
          MÁS ELEGIDO
          <StarIcon style={{
          fontSize: 12
        }} data-id="element-232" />
        </div>

        <div className="p-4 flex items-center gap-3" data-id="element-233">
          {/* Radio indicator */}
          <div className={`w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center transition-colors ${selected === 'premium' ? 'border-brand-pink' : 'border-gray-300'}`} data-id="element-234">
            {selected === 'premium' && <div className="w-2.5 h-2.5 rounded-full bg-brand-pink" data-id="element-235" />}
          </div>

          <div className="relative shrink-0" data-id="element-236">
            <EmojiEventsIcon className="text-brand-pink" style={{
            fontSize: 28
          }} data-id="element-237" />
            <StarIcon className="text-yellow-400 absolute -top-1 -right-1" style={{
            fontSize: 14
          }} data-id="element-238" />
          </div>

          <div className="flex-grow min-w-0" data-id="element-239">
            <h4 className="font-heading text-base md:text-lg font-bold text-brand-dark leading-tight" data-id="element-240">
              PACK + <span className="text-brand-pink" data-id="element-241">CLASES GRABADAS</span>
            </h4>
            <p className="text-brand-text text-[11px] md:text-xs" data-id="element-242">
              Todo el Pack + 🎥 Videos paso a paso
            </p>
            <p className="text-brand-purple text-[11px] md:text-xs font-semibold" data-id="element-243">
              Acelerá viendo cada técnica en video
            </p>
          </div>

          <div className="text-right shrink-0" data-id="element-244">
            <p className="text-gray-400 line-through text-[11px] font-medium" data-id="element-245">
              $69.999
            </p>
            <p className="text-brand-pink font-black text-base md:text-lg" data-id="element-246">
              $29.999
              <span className="text-[10px] font-bold ml-0.5" data-id="element-247">ARS</span>
            </p>
          </div>
        </div>
      </button>

      {/* Single CTA */}
      <a href={current.url} className="block w-full bg-brand-coral hover:bg-brand-coralHover text-white font-bold text-base md:text-lg py-4 px-4 rounded-xl shadow-glow transition-all transform hover:-translate-y-1 active:translate-y-0 text-center mt-5" data-id="element-248">
        {current.label}
      </a>

      <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-5 text-xs md:text-sm text-gray-600 font-medium mt-3" data-id="element-249">
        <div className="flex items-center gap-1" data-id="element-250">
          <LockIcon fontSize="small" className="text-green-500" data-id="element-251" /> Pago seguro
        </div>
        <div className="flex items-center gap-1" data-id="element-252">
          <span className="text-green-500 text-lg" data-id="element-253">⚡</span> Acceso inmediato
        </div>
        <div className="flex items-center gap-1" data-id="element-254">
          <ShieldIcon fontSize="small" className="text-green-500" data-id="element-255" /> Garantía 7
          días
        </div>
      </div>
    </section>;
}